import { useMemo } from "react"
import { useLocation } from "./use-location"
import { graphql, useStaticQuery } from "gatsby"
import { PRODUCTS } from "./constants"
export { PRODUCTS }

// Should be updated to use Regex in the future
const isPageInArray = (page, array) => {
  return array.some(item => page.pathname.startsWith(item.path))
}

export const useProduct = () => {
  const { paths } = useStaticQuery(
    graphql`
      query UseProductQuery {
        paths: siteConfig {
          agnostic_pages {
            path
          }
          powermetrics_pages {
            path
          }
          klips_pages {
            path
          }
        }
      }
    `
  )

  const location = useLocation()
  const product = useMemo(() => {
    if (location.origin === "getpowermetrics.com") {
      return PRODUCTS.POWERMETRICS
    }
    
    if (location.pathname === "/" || location.pathname === "/home") {
      return PRODUCTS.AGNOSTIC
    } else if (isPageInArray(location, paths.agnostic_pages)) {
      return PRODUCTS.AGNOSTIC
    } else if (isPageInArray(location, paths.powermetrics_pages)) {
      return PRODUCTS.POWERMETRICS
    } else if (isPageInArray(location, paths.klips_pages)) {
      return PRODUCTS.KLIPS
    } else {
      return PRODUCTS.AGNOSTIC
    }
  }, [location])

  return { location, product }
}
